import styled from 'styled-components';
import TextView from '../../TextView';

// Main container
export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 8px;
  box-sizing: border-box;
  font-family: 'Inter, sans-serif';
  position: relative;

  @media (max-width: 480px) {
    padding: 8px;
  }
`;

// Header
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  width: 100%;

  @media (max-width: 480px) {
    gap: 8px;
  }
`;

// Expand/Collapse button
export const ExpandButton = styled.button`
  flex-shrink: 0;
  display: ${(props) => (props.showIcon ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  padding: 2px;
  margin-left: 8px;
  background-color: white;
  color: #333;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color:rgb(238, 238, 238);
  }

  @media (max-width: 480px) {
    padding: 5px 10px;
  }
`;

// Icon Container
export const IconContainer = styled.div`
  background: ${(props) => props.bgColor};
  color: white;
  border: none;
  border-radius: 4px;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
`;

// Title
export const Title = styled(TextView)`
  display: block;
  align-items: center;
  gap: 1px;
  font-size: 1rem;
  font-weight: 500;
  color: #123051;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 0.75rem;
  }

  @media (max-width: 480px) {
    font-size: 0.5rem;
  }

  span {
    color: #bbbbbb;
    font-weight: normal;
  }
`;
